import { ErrorBoundary } from '@sentry/react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { IndicatorTailwind } from 'src/components/indicators/IndicatorTailwind';
import { Toaster } from 'src/components/ui/sonner';
import { dpConfig } from 'src/config';
import { DefaultGuard } from 'src/guards/DefaultGuard';
import { ErrorsPage } from 'src/pages/errors/ErrorsPage';
import { NotFoundPage } from 'src/pages/errors/NotFoundPage';
import { RootErrorFallback } from 'src/pages/errors/RootErrorFallback';

const TanStackRouterDevtools = ['production', 'staging'].includes(
  `${dpConfig.env}`,
)
  ? () => null
  : lazy(() =>
      import('@tanstack/react-router-devtools').then((res) => ({
        default: res.TanStackRouterDevtools,
      })),
    );

const ReactQueryDevtools = ['production', 'staging'].includes(`${dpConfig.env}`)
  ? () => null
  : lazy(() =>
      import('@tanstack/react-query-devtools').then((res) => ({
        default: res.ReactQueryDevtools,
      })),
    );

export const RootRoute = createRootRoute({
  component: () => (
    <DefaultGuard>
      <ErrorBoundary fallback={() => <RootErrorFallback />}>
        <Outlet />
      </ErrorBoundary>
      <Toaster closeButton richColors />
      <IndicatorTailwind />
      <Suspense>
        <TanStackRouterDevtools position='bottom-right' />
        <ReactQueryDevtools position='bottom' />
      </Suspense>
    </DefaultGuard>
  ),
  notFoundComponent: () => (
    <ErrorsPage>
      <NotFoundPage />
    </ErrorsPage>
  ),
});
